import { render } from "./installationEditRooms.vue?vue&type=template&id=41595a06&scoped=true"
import script from "./installationEditRooms.vue?vue&type=script&lang=js"
export * from "./installationEditRooms.vue?vue&type=script&lang=js"

import "./installationEditRooms.vue?vue&type=style&index=0&id=41595a06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41595a06"]])

export default __exports__